module.exports = require('./helpers/bundle-url').getBundleURL('kuLgW') + "football_pen_miss.d0ef19de.png";